export default function createUserReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_USER_ROLE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_USER_ROLE_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_USER_ROLE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}